import styled from 'styled-components';

import { pickColor } from 'themes/helpers/pickColor';

import { Input } from 'components/Input';

const Wrapper = styled.div`
  position: relative;

  width: 100%;
`;

const SearchInput = styled(Input)`
  height: 100%;
  width: 100%;

  display: block;

  input {
    height: 100%;
    width: 100%;

    border: none;

    font-size: 3.2rem;
    font-weight: 600;

    letter-spacing: 0.2rem;

    color: ${pickColor('black')};

    &:focus {
      outline-width: 0;
    }

    &::placeholder {
      color: ${pickColor('grayDark')};
    }
  }
`;

const Results = styled.div`
  position: absolute;
  left: 0;
  right: 0;
  top: ${({ theme }) => theme.headerHeight};

  width: 100%;
  max-height: 60vh;
  overflow-y: auto;

  background: ${pickColor('white')};
  border: 0.1rem solid ${pickColor('black')};
  z-index: 1000;
`;

const ResultsList = styled.div`
  display: flex;
  flex-direction: column;
`;

const ResultItem = styled.div`
  display: flex;
  align-items: center;
  gap: 2rem;
  padding: 1.5rem;
  cursor: pointer;
  border-bottom: 0.1rem solid ${pickColor('grayLight')};

  &:hover {
    background: ${pickColor('grayLight')};
  }

  &:last-child {
    border-bottom: none;
  }
`;

const ResultImageWrapper = styled.div`
  position: relative;
  width: 12rem;
  height: 12rem;
  flex-shrink: 0;
`;

const ResultImage = styled.img<{ $isInactive?: boolean }>`
  width: 12rem;
  height: 12rem;
  object-fit: cover;
  opacity: ${({ $isInactive }) => ($isInactive ? 0.35 : 1)};
`;

const InactiveLayer = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  pointer-events: none;
`;

const ResultInfo = styled.div`
  display: flex;
  flex-direction: row;
  gap: 3rem;
  flex: 1;
  align-items: center;
  min-width: 0;
`;

const ResultColumn = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  min-width: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

const ResultCategory = styled.div`
  font-size: 1.4rem;
  font-weight: 500;
  color: ${pickColor('black')};
  text-transform: uppercase;
`;

const ResultCode = styled.div`
  font-size: 1.4rem;
  font-weight: 500;
  color: ${pickColor('black')};
  text-transform: uppercase;
`;

const ResultColor = styled.div`
  font-size: 1.4rem;
  font-weight: 500;
  color: ${pickColor('black')};
  text-transform: uppercase;
`;

const NoResults = styled.div`
  padding: 2rem;
  text-align: center;
  font-size: 1.4rem;
  color: ${pickColor('grayDark')};
`;

export {
  Wrapper,
  SearchInput,
  Results,
  ResultsList,
  ResultItem,
  ResultImageWrapper,
  ResultImage,
  InactiveLayer,
  ResultInfo,
  ResultColumn,
  ResultCategory,
  ResultCode,
  ResultColor,
  NoResults,
};
